import React, { useCallback } from 'react';
import { useTranslation } from '../../../localization/useTranslation';
import { Switch } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';

const SwitchComponent = ({ model, value, onChange }) => {
  const T = useTranslation();

  const _onChange = useCallback((unusedEvt, isChecked) => {
    onChange(model, isChecked);
  }, [model, onChange]);

  return (
    <Switch
      id={model.path}
      label={(model?.onlySwitch) ? '' : T.localize(model.label)}
      aria-label={model.label}
      isReversed={(model?.isReversed) ? true : false}
      isChecked={value}
      onChange={_onChange}
      isDisabled={model?.properties?.isDisabled}
    />
  );
};

SwitchComponent.propTypes = ComponentPropTypes;

export default React.memo(SwitchComponent);
